class WishlistManager {
    constructor() {
        this.boundHandleClick = this.handleButtonClick.bind(this);
        this.wishlistContainer = document.querySelector('[data-wishlist-button-header]');
        this.countBubble = this.wishlistContainer?.querySelector('.mm-wishlist-count-bubble');
        this.initializeWishlist();
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.addEventListener('ooo-wishlist:product-added', (event) => {
            const count = event.detail.wishlist_product_list.length;
            this.updateUI(count);
        });

        document.addEventListener('ooo-wishlist:product-removed', (event) => {
            const count = event.detail.wishlist_product_list.length;
            this.updateUI(count);
        });
    }

    async handleButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const button = e.currentTarget;
        const handle = button.dataset.productHandle;
        if (!handle) return;

        try {
            const isCurrentlyActive = button.classList.contains('active');
            
            // Action API
            await (isCurrentlyActive 
                ? window.Maestrooo.wishlist.removeProduct(handle)
                : window.Maestrooo.wishlist.addProduct(handle));
            
            // Mise à jour visuelle du bouton
            this.updateButtonState(button, !isCurrentlyActive);
            
            // Mise à jour de la page wishlist si nécessaire
            const wishlistSection = document.querySelector('wishlist-products-section');
            if (wishlistSection && isCurrentlyActive) {
                await wishlistSection.loadWishlistProducts();
            }
        } catch (error) {
            console.error('Erreur wishlist:', error);
        }
    }

    updateUI(count) {
        if (!this.countBubble || !this.wishlistContainer) return;
        
        this.countBubble.textContent = count;
        this.countBubble.classList.toggle('hidden', count === 0);
        this.wishlistContainer.classList.toggle('active', count > 0);
    }

    updateButtonState(button, isActive) {
        button.classList.toggle('active', isActive);
        button.dataset.added = isActive ? 'true' : null;
    }

    async initButtons() {
        const wishlistButtons = document.querySelectorAll('[data-wishlist-button]');
        if (!wishlistButtons.length) return;

        const promises = Array.from(wishlistButtons).map(async button => {
            // Le widget tiers ooo-wl-wishlist-button gère deja son propre clic et son propre etat (aria-checked).
            // Le laisser + notre propre handler declenche un double appel addProduct/removeProduct sur le meme produit (409/500 cote API).
            if (button.querySelector('ooo-wl-wishlist-button')) return;

            const handle = button.dataset.productHandle;
            if (!handle) return;

            button.removeEventListener('click', this.boundHandleClick);
            button.addEventListener('click', this.boundHandleClick);

            try {
                const isInWishlist = await window.Maestrooo.wishlist.containsProduct(handle);
                this.updateButtonState(button, isInWishlist);
            } catch (error) {
                console.error('Erreur état initial:', error);
            }
        });

        await Promise.all(promises);
    }

    async initializeWishlist() {
        try {
            const content = await window.Maestrooo.wishlist.getContent();
            this.updateUI(content?.products?.length || 0);
            await this.initButtons();
        } catch (error) {
            console.error('Erreur initialisation wishlist:', error);
        }
    }
}

// Initialisation unique
const initWishlistManager = () => {
    if (!window.wishlistManager) {
        window.wishlistManager = new WishlistManager();
    }
};

document.addEventListener('DOMContentLoaded', initWishlistManager);